import { observer } from 'mobx-react-lite'
import { ProfileHeader } from 'page/ProfileHeader'
import { FullProfilePage } from 'page/ProfileScreen/FullProfilePage/FullProfilePage'
import { SelfieProfilePage } from 'page/ProfileScreen/pages/SelfieProfilePage'
import { SimpleProfilePage } from 'page/ProfileScreen/Simple/SimpleProfilePage'
import { store } from 'store/store'

function page() {
  const key = store.profile?.identity_id || 'none'
  const photo = store.profile?.type

  if (photo === 'full') return <FullProfilePage key={key} />
  if (photo === 'simple') return <SimpleProfilePage key={key} />
  return <SelfieProfilePage key={key} />
}

export const ProfilePages = observer(() => {
  return <>
    {page()}
    <ProfileHeader />
  </>
})
